import BaseController from "controllers/backend/base"

import ResultsFilterWidget from "widgets/backend/resultsFilterWidget"
import { ajax } from "jquery"

class Controller extends BaseController {
  call() {
    super.call()
    hideSpinner.call(this)
    bindreReimportButton.call(this)
  }
};

const hideSpinner = function(){
  this.root.find('.loading-spinner').hide()
}

var bindreReimportButton = function() {
  this.root.on('.import-vehicle-dump').on("click", (e) => {
    if (e.target.classList.contains("import-vehicle-dump")) {
      e.preventDefault();
      e.stopPropagation();
      const root = this.root;
      const $element = $(e.target)
      $.ajax({
        url: $element.attr("href"),
        method: "get",
        beforeSend: function(){
          root.find('.loading-spinner').show()
        },
        success: function(response){
          root.find('.loading-spinner').hide()
          const { record:{ LOTSKU, last_error } } = response
          if (response.import_success) {
            swal({
              type: "success",
              title: `${LOTSKU} imported`
            }).then(()=> {
              location.reload();
            })
          } else {
            swal({
              type: "error",
              title: `${LOTSKU} not imported`,
              text: last_error
            }).then(()=> {
              location.reload();
            })
          }
        },
        error: function(error){
          root.find('.loading-spinner').hide()
          swal({
            type: "error",
            title: "Something went wrong",
            text: "Please try again later"
          }).then(()=> {
            location.reload();
          })
        }
      })
    }
  })
}

export default Controller;